import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import HomeRedesign from '../Components/homesection/HomeRedesign'

function HomeLayout() {
  return (
    <>
    <Header />
    <HomeRedesign />
    <Footer />
    </>
  )
}

export default HomeLayout
